export default "__VITE_ASSET__B2jlaAAk__"